const widgetSizeExpandShrink = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M13.75 3.823v-1.5H2.25v1.5zM8 14l3.54-3.677H8.842v-4.1h4.908v-1.5H2.25v1.5H7.2v4.1H4.46z"/></svg>',
};

export { widgetSizeExpandShrink as default };
